import React from 'react';
import Api from './api.js';
import getResizeDetectorIns from './element-resize-detector-adapter.js';
import tabsMoreButton from 'tabs-more-button';
import ShowMoreTabs from './show-more-tabs.js';
var getDeps = function getDeps() {
  return {
    getResizeDetectorIns: getResizeDetectorIns,
    getInstance: function getInstance(ctx, setHiddenTabIDs) {
      return new Api({
        setHiddenTabIDs: setHiddenTabIDs,
        btnRef: /*#__PURE__*/React.createRef(),
        getResizerIns: function getResizerIns(options) {
          return new (Function.prototype.bind.apply(tabsMoreButton))(options);
        },
        ctx: ctx
      });
    }
  };
};
export default ShowMoreTabs.bind(null, getDeps);